module.exports = __webpack_public_path__ + "img/4785.d8e9c565.jpg";